export enum DesignSection {
  SHAPES = 'SHAPES',
  EDGES = 'EDGES',
  CORNER_RADIUS = 'CORNER_RADIUS',
  DIAGONAL_CORNERS = 'DIAGONAL_CORNERS',
  CUSTOM_SIDES = 'CUSTOM_SIDES',
  SINKS = 'SINKS',
  COOKING_APPLIANCES = 'COOKING_APPLIANCES',
  CUTOUTS = 'CUTOUTS',
  TEAR_OUTS = 'TEAR_OUTS',
  OPTIONAL_PRODUCTS = 'OPTIONAL_PRODUCTS',
  PLUMBING = 'PLUMBING',
}
